import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractTypeMgsParameterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypeMgsParameterCreateDto,
  ContractTypeMgsParameterDto,
  ContractTypeMgsParameterExcelDownloadDto,
  ContractTypeMgsParameterUpdateDto,
} from '../proxy/controlling/dtos/contract-type-mgs-parameter';
import { CONTRACTTYPEMGSPARAMETER_CONFIG, CONTRACTTYPEMGSPARAMETER_FIELDS } from './contract-type-mgs-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-type-mgs-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractTypeMgsParameterService, ConfirmationService],
  templateUrl: './contract-type-mgs-parameter.html',
  styleUrl: './contract-type-mgs-parameter.scss',
})
export class ContractTypeMgsParameter extends BaseHierarchicalCrudComponent<
  ContractTypeMgsParameterDto,
  ContractTypeMgsParameterCreateDto,
  ContractTypeMgsParameterUpdateDto,
  ContractTypeMgsParameterExcelDownloadDto
> {
  service = inject(ContractTypeMgsParameterService);
  config = CONTRACTTYPEMGSPARAMETER_CONFIG;
  fields = CONTRACTTYPEMGSPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypeMgsParameterDto): ContractTypeMgsParameterUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractTypeMgsParameter';
  }
}
